export function LoadingState({ label = "불러오는 중" }: { label?: string }) {
	return (
		<div className="loading-state" role="status" aria-live="polite">
			<span className="loading-state__spinner" aria-hidden="true" />
			<span>{label}</span>
		</div>
	);
}
